import React from 'react';
import { useNavigate } from 'react-router-dom';

const Footer: React.FC = () => {
  const navigate = useNavigate();

  return (
    <footer className="va-footer">
      <div className="va-container">
        <div className="va-footer-grid">
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.65rem', marginBottom: '0.85rem' }}>
              <span className="va-logo-mark">VA</span>
              <span className="va-logo-text">VakaAfrica</span>
            </div>
            <p className="va-body" style={{ maxWidth: '28rem' }}>
              Mining and construction equipment and reagents for African operations that need reliable supply and clear specifications.
            </p>
          </div>

          <div>
            <p className="va-label" style={{ marginBottom: '0.85rem' }}>Navigate</p>
            <div className="va-footer-links">
              <button type="button" onClick={() => navigate('/')}>Home</button>
              <button type="button" onClick={() => navigate('/shop')}>Shop</button>
            </div>
          </div>

          <div>
            <p className="va-label" style={{ marginBottom: '0.85rem' }}>Contact</p>
            <p className="va-body">munya@vakaafrica.com</p>
            <p className="va-body" style={{ marginTop: '0.35rem' }}>+263 777 944 672</p>
          </div>
        </div>

        <div className="va-footer-bottom">
          <span>© {new Date().getFullYear()} VakaAfrica. All rights reserved.</span>
          <span>Mining and construction supply</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
